import { useAppDispatch, useAppSelector } from '../store'
import { 
    selectContext, 
    setContext as setContextInState, 
    updateContext as updateContextInState,
} from 'store/applicationSlice'

export const useContext = () => {
    const dispatch = useAppDispatch()
    const context = useAppSelector(selectContext)

    const setContext = (context: any) => {
        dispatch(setContextInState(context))
    }

    const updateContext = (context: any) => {
        dispatch(updateContextInState(context))
    }
  
    return {
        context,
        setContext,
        updateContext
    }
}